/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Terms_DescriptionInputs */

const en_legal_terms_description = /** @type {(inputs: Legal_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rules for using Complete Athlete as an athlete.`)
};

const pl_legal_terms_description = /** @type {(inputs: Legal_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasady korzystania z Complete Athlete przez sportowców.`)
};

/**
* | output |
* | --- |
* | "The rules for using Complete Athlete as an athlete." |
*
* @param {Legal_Terms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_terms_description = /** @type {((inputs?: Legal_Terms_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Terms_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_terms_description(inputs)
	return en_legal_terms_description(inputs)
});